import React from 'react'
import cn from 'classnames'
import { Tabs, Typography } from '@grammarly/badger-ui'
import { VerticalTabsProps } from '../types'
import { TabContent } from '../tab-content'
import styles from './tabs-view.module.scss'
import { getColorStyleClassName } from '../utils'

export const TabsView: React.FC<VerticalTabsProps> = ({ items, className, colorStyle }) => {
  const colorStyleClassName = getColorStyleClassName(colorStyle)

  return (
    <Tabs id="Vertical Tabs" orientation="vertical" className={cn(styles.verticalTabsContainer, className)}>
      <Tabs.TabList className={styles.verticalTabList}>
        {items.map(({ title }, index) => (
          <Tabs.Tab key={index} className={cn(styles.verticalTab, colorStyleClassName)}>
            <Typography.HS as={'h4'}>{title}</Typography.HS>
          </Tabs.Tab>
        ))}
      </Tabs.TabList>

      <Tabs.TabPanels>
        {items.map(({ content }, index) => {
          return (
            <Tabs.TabPanel key={index} className={styles.tabPanel}>
              <TabContent content={content} />
            </Tabs.TabPanel>
          )
        })}
      </Tabs.TabPanels>
    </Tabs>
  )
}
